import { render, staticRenderFns } from "./modify-role.vue?vue&type=template&id=e02903da&scoped=true"
import script from "./modify-role.vue?vue&type=script&lang=ts"
export * from "./modify-role.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02903da",
  null
  
)

export default component.exports